import MenuItem from "@mui/material/MenuItem";
import React, { ReactNode, useState } from "react";
import { StyledMenu } from "../ui";
import { TriangleIcon } from "../images";
import { CustomButton } from "../ui/CustomButton";
import { GenerateReportsModals } from "../../types/enums";
import { useGetCampaignSummaryQuery } from "../../api";
import { useParams } from "react-router-dom";
import { GeneratePlaybookForAccountsModal } from "../ui/modal/GeneratePlaybookForAccountsModal";
import { TargetAccountPlansBtn } from "../ui/buttons";
import { CircularProgress } from "@mui/material";

export const GenerateReportsMenu = () => {
  const { campaign_id } = useParams();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [currentModal, setCurrentModal] = useState<GenerateReportsModals>(
    GenerateReportsModals.none,
  );

  const { data } = useGetCampaignSummaryQuery({
    campaign_id: campaign_id!,
  });

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setCurrentModal(GenerateReportsModals.none);
  };

  const openModalHandler = (modal: GenerateReportsModals) => {
    setCurrentModal(modal);
  };

  const options = [
    {
      label: GenerateReportsModals.account_plan,
      isDisabled: !data?.has_accounts_without_plan,
    },
    {
      label: GenerateReportsModals.playbook,
      isDisabled: !data?.has_accounts_without_playbook,
    },
  ];

  const modals: Record<GenerateReportsModals, ReactNode> = {
    [GenerateReportsModals.account_plan]: (
      <TargetAccountPlansBtn
        campaign_id={campaign_id!}
        onClose={handleClose}
        hideBtn={true}
        setIsLoading={setIsLoading}
      />
    ),
    [GenerateReportsModals.playbook]: (
      <GeneratePlaybookForAccountsModal
        isOpen={true}
        onClose={handleClose}
        setIsLoading={setIsLoading}
      />
    ),
    [GenerateReportsModals.none]: null,
  };

  return (
    <div>
      <CustomButton
        onClick={handleClick}
        variant="outlined"
        customColor="#FFFFFF"
        textColor="#BD4D00"
        customSize="fit"
        type="button"
        endIcon={<TriangleIcon color={"#BD4D00"} />}
        sx={{ padding: "8px 16px" }}
      >
        Get Targeted Reports
      </CustomButton>

      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "white",
          },
        }}
      >
        {options.map(({ label, isDisabled }) => (
          <MenuItem
            key={label}
            sx={{ display: "flex", gap: "12px", alignItems: "center" }}
            onClick={() => openModalHandler(label)}
            disabled={isDisabled || isLoading}
          >
            {label}
            {isLoading && label === currentModal && (
              <CircularProgress size={20} color="inherit" />
            )}
          </MenuItem>
        ))}
      </StyledMenu>
      {modals[currentModal]}
    </div>
  );
};
